<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [dismissableMask]="false"
  styleClass="decline-request-container"
  (onHide)="onHide()"
  [draggable]="false"
  [resizable]="false"
>
  <!-- Header Template for consistent styling -->
  <ng-template pTemplate="header">
    <div class="modal-header">
      <h2>Decline Request</h2>
    </div>
  </ng-template>

  <!-- Modal Body with form -->
  <div class="modal-body">
    <div class="p-fluid">
      <div class="p-field">
        <label for="remark">Remark</label>
        <textarea
          id="remark"
          pInputTextarea
          pTextareaAutosize
          [(ngModel)]="remark"
          rows="5"
          cols="30"
          placeholder="Please enter the remarks"
        ></textarea>
      </div>
    </div>
  </div>

  <!-- Footer Template with right-aligned button -->
  <ng-template pTemplate="footer">
    <div class="footer-buttons">
      <button pButton label="Save" class="p-button-warning" (click)="onSave()" [disabled]="!remark || !remark.trim()"></button>
    </div>
  </ng-template>
</p-dialog>
